import { WireScene } from './preview.js';
import ConfiguratorForm from './configurator-form.js';
import Configurator from './configurator.js';

const Cart = {
    items:       [],
    cartHash:    null,
    isDirty:     true,
    scenes:      {},

    init() {
        this.bindEvents();
    },

    bindEvents() {
        jQuery('#toggle-cart, #view-cart').on('click', () => {
            if (this.isDirty) {
                this.fetchAndRender();
            }
        });

        jQuery('#go-home').on('click', (e) => {
            e.preventDefault();
            Configurator.goToSlide(0);
            ConfiguratorForm.resetForm();
            jQuery('#cable-added-to-cart').addClass('hidden');
            jQuery('#reset').removeClass('hidden');
            jQuery('body').removeClass('cart-open');
        });
    },

    markDirty() {
        this.isDirty = true;
    },

    async fetchAndRender() {
        try {
            const response = await jQuery.ajax({
                xhrFields: {
                    withCredentials: true,
                },
                url:    VendorData.apiBase.replace('cart/v1', 'wc/store/v1') + '/cart',
                method: 'GET',
            });

            const newHash = this.hashItems(response.items);

            if (newHash === this.cartHash) return;

            this.cartHash = newHash;
            this.isDirty  = false;
            this.items    = response.items;

            this.destroyScenes();
            this.renderCartItems(response.items);

        } catch (e) {
            console.error('Failed to fetch cart:', e);
        }
    },

    hashItems(items) {
        return items.map(i => i.key + i.quantity).join('|');
    },

    destroyScenes() {
        Object.values(this.scenes).forEach(scene => scene.destroy());
        this.scenes = {};
    },

    renderCartItems(items) {
        const container = jQuery('#cart-edit-update');
        container.empty();

        if (!items || items.length === 0) {
            container.html('<div class="empty-cart"><p>The quote cart is empty</p><button id="go-home" class="button">Create Quote</button></div>');
            jQuery('.cart-right').hide();
            jQuery('#go-home').on('click', (e) => {
                e.preventDefault();
                Configurator.goToSlide(0);
                ConfiguratorForm.resetForm();
                jQuery('#cable-added-to-cart').addClass('hidden');
                jQuery('#reset').removeClass('hidden');
                jQuery('body').removeClass('cart-open');

            });
            return;
        }

        jQuery('.cart-right').show();

        items.forEach((item, index) => {
            const data     = this.parseItemData(item.item_data);
            const selection = this.resolveSelection(data);
            const html     = this.buildItemHtml(item, data, index);

            container.append(html);

            // Init Three.js scene for this item
            const canvasId = 'cart-canvas-' + index;
            this.initItemScene(canvasId, selection);
        });
    },

    parseItemData(itemData) {
        const data = {};
        itemData.forEach(entry => {
            data[entry.name] = entry.value;
        });
        return data;
    },

    resolveSelection( data ) {
        const selection = {
            wireId:           null,
            leftLugId:        null,
            leftShrinkId:     null,
            rightLugId:       null,
            rightShrinkId:    null,
            rightEndType:     'stripped-retained',
            rightNoConnection: false,
        };

        const wires       = VendorData.products.wires;
        const lugs        = VendorData.products.lugs;
        const heatshrinks = VendorData.products.heatshrinks;

        if ( data['Wire'] ) {
            const wire = Object.values( wires ).find( w => w.part_number === data['Wire'] );
            if ( wire ) selection.wireId = wire.id;
        }

        if ( data['Left Lug'] ) {
            const lug = Object.values( lugs ).find( l => l.part_number === data['Left Lug'] );
            if ( lug ) selection.leftLugId = lug.id;
        }

        if ( data['Left Heatshrink'] ) {
            const hs = Object.values( heatshrinks ).find( h => h.part_number === data['Left Heatshrink'] );
            if ( hs ) selection.leftShrinkId = hs.id;
        }

        if ( data['Right Lug'] ) {
            const lug = Object.values( lugs ).find( l => l.part_number === data['Right Lug'] );
            if ( lug ) selection.rightLugId = lug.id;
        } else {
            /* No right lug means no connection */
            selection.rightNoConnection = true;
        }

        if ( data['Right Heatshrink'] ) {
            const hs = Object.values( heatshrinks ).find( h => h.part_number === data['Right Heatshrink'] );
            if ( hs ) selection.rightShrinkId = hs.id;
        }

        /* Resolve right end type from stored label back to value */
        const endTypeMap = {
            'Stripped & Retained': 'stripped-retained',
            'Stripped':            'stripped',
            'Blunt End':           'blunt-end',
        };
        const endTypeRaw = data['Right End Treatment'] ?? data['Right End Type'] ?? null;
        if ( endTypeRaw ) {
            selection.rightEndType = endTypeMap[ endTypeRaw ] ?? endTypeRaw;
        }

        return selection;
    },

    buildItemHtml(item, data, index) {
        
        // Reverse lookup wire for gauge and color
        const wirePart = data['Wire'] || null;
        const wire     = wirePart ? Object.values(VendorData.products.wires).find(w => w.part_number === wirePart) : null;
        
        const gauge       = wire?.wire_size       || '-';
        const color       = wire?.jacket_color    || '-';
        const length      = data['Wire Length']    || '-';
        const leftLug     = data['Left Lug']       || '-';
        const leftShrink  = data['Left Heatshrink'] || 'None';
        const rightLug    = data['Right Lug']      || '-';
        const rightShrink = data['Right Heatshrink'] || 'None';
        const quantity    = item.quantity;
        const number      = index + 1;
        const rightEndType    = data['Right End Type']    || null;
        const rightStripLength = data['Right Strip Length'] || null;      
        
        console.log(data);
        console.log(rightEndType);

        const rightEndTypeLabel = rightEndType === 'stripped-retained' ? 'Stripped & Retained'
                                : rightEndType === 'stripped'          ? 'Stripped'
                                : rightEndType === 'blunt-end'         ? 'Blunt End'
                                : null;

        const checkboxLabels = jQuery( 'input[name="options[]"]' )
            .map( ( i, el ) => jQuery( el ).val() ).get();


        const decodedData = {};
        Object.entries( data ).forEach( ( [ k, v ] ) => {
            const txt = document.createElement( 'textarea' );
            txt.innerHTML = k;
            decodedData[ txt.value ] = v;
        } );
            

        const checkboxesHtml = checkboxLabels
            .filter( label => decodedData[ label ] === 'Yes' )
            .map( label => `<span class="cart-item__checkbox">${ label }</span>` )
            .join( ', ' );

        return `
            <div class="cart-item" data-key="${item.key}">
                <div class="cart-item__title">Cable ${number}</div>
                <div class="cart-item__preview">
                    <div class="cart-item__canvas" id="cart-canvas-${index}"></div>
                </div>
                <div class="cart-item__details">
                    <div class="cart-item__col">
                        <span class="cart-item__label">Left Termination</span>
                        <div class="cart-item__row">
                            <span class="cart-item__key">Termination L</span>
                            <span class="cart-item__val">${leftLug}</span>
                        </div>
                        <div class="cart-item__row">
                            <span class="cart-item__key">Shrink L</span>
                            <span class="cart-item__val">${leftShrink}</span>
                        </div>
                    </div>
                    <div class="cart-item__col cart-item__col--center">
                        <span class="cart-item__label">Cable</span>
                        <div class="cart-item__row">
                            <span class="cart-item__key">Gauge</span>
                            <span class="cart-item__val">${gauge}</span>
                        </div>
                        <div class="cart-item__row">
                            <span class="cart-item__key">Length</span>
                            <span class="cart-item__val">${length}</span>
                        </div>
                        <div class="cart-item__row">
                            <span class="cart-item__key">Color</span>
                            <span class="cart-item__val">${color}</span>
                        </div>
                    </div>
                    <div class="cart-item__col cart-item__col--right">
                        <span class="cart-item__label">Right Termination</span>
                        <div class="cart-item__row">
                            <span class="cart-item__key">Termination R</span>
                            <span class="cart-item__val">${rightLug}</span>
                        </div>
                        ${ rightEndTypeLabel ? `
                        <div class="cart-item__row">
                            <span class="cart-item__key">End Treatment</span>
                            <span class="cart-item__val">${ rightEndTypeLabel }</span>
                        </div>` : '' }
                        ${ rightStripLength && ( rightEndType === 'stripped' || rightEndType === 'stripped-retained' )  ? `
                        <div class="cart-item__row">
                            <span class="cart-item__key">Strip Length</span>
                            <span class="cart-item__val">${ rightStripLength } ${ jQuery('#measure').val() }</span>
                        </div>` : '' }
                        <div class="cart-item__row">
                            <span class="cart-item__key">Shrink R</span>
                            <span class="cart-item__val">${rightShrink}</span>
                        </div>
                    </div>
                </div>
                <div class="cart-item__footer">
                    <span class="cart-item__checkboxes"><strong>Logistic support options selected:</strong> ${ checkboxesHtml ? ` ${ checkboxesHtml }` : 'None' }</span>
                    <button class="cart-item__edit"   data-key="${item.key}">Edit</button>
                    <span   class="cart-item__qty">${quantity}</span>
                    <button class="cart-item__delete" data-key="${item.key}">Delete</button>
                </div>
            </div>
        `;
    },

    initItemScene(canvasId, selection) {
        // Wait for DOM to be ready
        setTimeout(() => {
            const scene = new WireScene();
            scene.init(canvasId, { controls: false, cameraZ: 12 });
            this.scenes[canvasId] = scene;
                
            if (selection.wireId) {
                scene.buildWireSet(selection);
            } else if (VendorData.defaultModelUrl) {
                scene.loadDefault(VendorData.defaultModelUrl);
            }
        }, 100);
    },

    bindCartItemEvents() {
        jQuery(document).on('click', '.cart-item__delete', (e) => {
            e.preventDefault();
            const key = jQuery(e.currentTarget).data('key');
            this.removeItem(key);
        });

        jQuery(document).on('click', '.cart-item__edit', (e) => {
            e.preventDefault();
            const key = jQuery(e.currentTarget).data('key');
            this.editItem(key);
        });
    },

    async removeItem(key) {
        try {
            await jQuery.ajax({
                url:         VendorData.apiBase + '/cart/remove-wire-set',
                method:      'POST',
                xhrFields: {
                    withCredentials: true,
                },
                headers:     { 'X-WP-Nonce': VendorData.restNonce ?? '' },
                contentType: 'application/json',
                data:        JSON.stringify({ cart_item_key: key }),
            });

            this.isDirty = true;
            this.fetchAndRender();
            jQuery(".cart-preview h3").show();
            jQuery('.cart-submit-quote').addClass('hidden');

        } catch (e) {
            console.error('Failed to remove item:', e);
        }
    },

    editItem( key ) {
        const item = this.items.find( i => i.key === key );
        if ( ! item ) return;

        const data = this.parseItemData( item.item_data );
        jQuery( 'body' ).removeClass( 'cart-open' );
        ConfiguratorForm.loadFromCartItem( key, data );
    },

    
};

export default Cart;